module.exports = __webpack_public_path__ + "img/cv.6e8e9eb8.jpg";